export const ATTACHMENT_TYPE = {
  VIDEO: 'video',
};
export const ATTACHMENT_TYPE_NUM = {
  [ATTACHMENT_TYPE.VIDEO]: 100,
} as const;

export const MAX_IMAGE_SIZE = 10000;

export const DEFAULT_IMAGE_UPLOAD_FAIL_MESSAGE =
  '이미지에 문제가 있어 업로드에 실패하였습니다. 다른 이미지로 다시 시도해주시기 바랍니다.';
